











import {CommonMixin} from "@/shared/services/mixin";
import {mixins} from "vue-class-component";
import {Component} from "vue-property-decorator";
import LadingFormExcel from "@/modules/ladings/FormExcel/index.vue";
@Component({
    name: "LadingExcel",
    components: {LadingFormExcel}
})
export default class extends mixins(CommonMixin){

}
